import { arrayOf, node, shape, string } from 'prop-types';
import React from 'react';

function Details({ data, className, labelClassName, valueClassName }) {
  return (
    <dl className={className}>
      {data.map(({ label, value }) => (
        <React.Fragment key={label}>
          <dt className={labelClassName}>{label}</dt>
          <dd className={valueClassName}>{value}</dd>
        </React.Fragment>
      ))}
    </dl>
  );
}

Details.propTypes = {
  className: string,
  labelClassName: string,
  valueClassName: string,
  data: arrayOf(
    shape({
      label: node,
      value: node,
    }).isRequired,
  ).isRequired,
};

Details.defaultProps = {
  className: undefined,
  labelClassName: undefined,
  valueClassName: undefined,
};

export default Details;
